import { FC } from 'react'

export const GroupBadge: FC<{ title: string }> = ({ title }) => (
  <div className="text-primary-base font-bold break-all whitespace-normal">
    <span className="flex items-center justify-center">
      <span className="bg-adm-accent-normalLighter inline-block rounded-lg px-2 py-1 text-xs">{title}</span>
    </span>
  </div>
)
